import { render } from "./MainDmd.vue?vue&type=template&id=23c2aa1a&scoped=true"
import script from "./MainDmd.vue?vue&type=script&lang=js"
export * from "./MainDmd.vue?vue&type=script&lang=js"

import "./MainDmd.vue?vue&type=style&index=0&id=23c2aa1a&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c2aa1a"]])

export default __exports__